export class ProjectConfigModel {}
